import { useState } from "react";
import axios from "axios";
import useInscricaoForm from "../hooks/useInscricaoForm";
import CamposInscricao from "./CamposInscricao";
import { Alert, Box, Button, CircularProgress, TextField } from "@mui/material";
import { Cartao, Pagina } from "./ui/Painel";

const InscricaoInterna = () => {
  const formulario = useInscricaoForm();
  const { formularioValido, validarCampos, payload, resetar } = formulario;
  const [mesa, setMesa] = useState("");
  const [enviando, setEnviando] = useState(false);
  const [mensagem, setMensagem] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validarCampos()) return;

    setEnviando(true);
    setMensagem(null);

    try {
      await axios.post(`${process.env.REACT_APP_API_URL}/participantes/inscricao-interna`, {
        ...payload(),
        mesa: mesa.trim() || undefined,
      });
      setMensagem({ type: "success", text: "Inscrição cadastrada! O QR Code foi enviado para o e-mail informado." });
      resetar();
      setMesa("");
    } catch (error) {
      setMensagem({
        type: "error",
        text: error.response?.data?.error || "Erro ao cadastrar inscrição.",
      });
    } finally {
      setEnviando(false);
    }
  };

  return (
    <Pagina
      eyebrow="Evento"
      titulo="Inscrição interna"
      descricao="Cadastro feito pela equipe (ex.: por telefone), sem captcha e sem limite de tentativas. O convidado recebe o QR Code por e-mail."
      largura={720}
    >
      <Cartao titulo="Dados do convidado">
        <Box component="form" onSubmit={handleSubmit} sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
          {mensagem && <Alert severity={mensagem.type}>{mensagem.text}</Alert>}

          <CamposInscricao formulario={formulario} />

          <TextField
            label="Mesa"
            size="small"
            fullWidth
            placeholder="Ex: 12"
            value={mesa}
            onChange={(e) => setMesa(e.target.value)}
            helperText="Opcional — só preencha se já souber a mesa da pessoa"
          />

          <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
            <Button type="submit" variant="contained" disabled={enviando || !formularioValido} sx={{ minWidth: 170 }}>
              {enviando ? <CircularProgress size={20} color="inherit" /> : "Cadastrar inscrição"}
            </Button>
          </Box>
        </Box>
      </Cartao>
    </Pagina>
  );
};

export default InscricaoInterna;
